import React from "react";
import { post } from "../../config/imagesLink";


const Loading = () => {
  return (
    <div className="loading-container">
      <div className="lds-ripple">
        {/* <div><img src={ post.loader} alt="" srcset="" /></div>         */}
      </div>
    </div>
  );
};

export default Loading;
